import { render, staticRenderFns } from "./MemberDetail.vue?vue&type=template&id=5611767f"
import script from "./MemberDetail.vue?vue&type=script&lang=js"
export * from "./MemberDetail.vue?vue&type=script&lang=js"
import style0 from "./MemberDetail.vue?vue&type=style&index=0&id=5611767f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports